import { MessageSeverity } from '../../enums/message-severity.enum';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { Guid } from '../guid';
import { IfRuleGroup } from '../if-gate/if-rule-group';

export class CustomMessageGroup extends DestinationTaskConfigBase {
	id = Guid();
	ruleGroup: IfRuleGroup = new IfRuleGroup();
	overwriteMessage = false;
	messageSeverity: MessageSeverity = MessageSeverity.Error;
	customMessage = '';

	constructor(init?: Partial<CustomMessageGroup>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
		if (!this.id) {
			this.id = Guid();
		}
	}
}
